import React  from "react";
import {ApplicantContainer} from "../unstated/applicant";
import Parents from "../containers/Parents";
import Siblings from "../containers/Siblings";
import CommunityCC from "../containers/CommunityCC";

export default function FamilyBackground() {
    
    let applicant = ApplicantContainer.useContainer();

    return (
    
        applicant.showFamilyBackground ?
    <>
    <Parents />
    <Siblings /> 
    {
      applicant.showCommunityCC ? 
      <CommunityCC />
      : <></>
    }
    </>
  :  <></>
    );
}